import { h } from 'preact';
const GiftboxGroupTab = ({ value , activeGroup , title , description , price , onSelect , children  })=>h('div', {
        className: 'giftbox-group__tab-group'
    }, [
        h('button', {
            type: 'button',
            role: 'radio',
            'data-testid': `gift-wrapping-tab-${value}`,
            className: `giftbox-group__tab${activeGroup === value ? ' is-active' : ''}`,
            'aria-checked': activeGroup === value,
            onClick: ()=>onSelect(value)
        }, [
            h('div', {
                className: 'giftbox-group__tab__box'
            }, [
                h('div', {
                    className: 'giftbox-group__tab__box__title'
                }, [
                    h('span', {
                        className: 'giftbox-group__tab__box__title__text'
                    }, title),
                    price ? h('span', {
                        className: 'giftbox-group__tab__box__title__price'
                    }, price) : null
                ]),
                h('div', {
                    className: 'giftbox-group__tab__box__description'
                }, description)
            ])
        ]),
        activeGroup === value ? children : null
    ]);
export { GiftboxGroupTab };
